import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { Country, CountryStatus, CountryUpsert, PagedResponse } from '../types'

const BASE = '/management/countries'

/**
 * Silinmemiş ülkelerin (ada göre sıralı) listesi. Tümü tek çağrıda çekilir (size=1000; canlı DB'de ~245
 * ülke) ve tabloda istemci tarafı sayfalanır (REF_COUNTRY'de SORT_INDEX yok → elle sıralama yerine sayfalama).
 */
export async function getCountries(): Promise<PagedResponse<Country>> {
  const { data } = await apiClient.get<PagedResponse<Country>>(BASE, {
    params: { page: 0, size: 1000 },
  })
  return data
}

/** Yeni ülke oluştur (201 → oluşturulan kayıt). */
export async function createCountry(body: CountryUpsert): Promise<Country> {
  const { data } = await apiClient.post<Country>(BASE, body)
  return data
}

/** Ülkeyi güncelle (ad; optimistic lock modDate zorunlu). */
export async function updateCountry(id: number, body: CountryUpsert): Promise<Country> {
  const { data } = await apiClient.put<Country>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeCountryStatus(id: number, body: CountryStatus): Promise<Country> {
  const { data } = await apiClient.put<Country>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteCountry(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Ülke listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportCountries(q?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { q }, 'ulkeler.xlsx')
}
